import React from "react";
import PriceCard from "../../components/common/PriceCard/PriceCard";
import Heading from "../../components/common/Typography/Heading";
import { getPricingPlan } from "../../data/pricingPlans";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_ABOUT_COLUMN_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from "../Public/shared/publicLayoutSpec";

const PricingGuide = () => {
  // Get pricing plan data
  const proPlan = getPricingPlan('pro');
  
  return (
    <>
    {/* <div className="bg-gradient-to-t from-transparent from-0% via-white via-10% to-mistygray to-40%"> */}
      <div
        className={`lg:flex items-center tp-container-main mx-auto w-full ${publicMainHeaderOffsetClass()} ${PUBLIC_ABOUT_COLUMN_GAP_CLASS}`}
      >
        <div>
          <Heading variant={"h1"} className={"!tertiary-heading !capitalize text-offblack"}>
            Upgrade to the Trades Poster Pro plan and unlock the full power of
            your business.
          </Heading>
        </div>
        <div
          className={`flex justify-center lg:justify-end shrink-0 ${PUBLIC_HEADING_TO_CONTENT_CLASS} lg:mt-0`}
        >
          <PriceCard
            tagging={proPlan.tagging}
            bottomLine={"border-b border-b-mediumgray pb-5"}
            MainDiveClasses={
              "bg-white text-offblack w-[350px] h-[550px] sm:w-[450px] sm:h-[650px] xl:w-[450px] 2xl:w-[500px] 2xl:h-[700px] pb-5 sm:pb-10 xl:pb-[45px]"
            }
            listClasses={"pl-[30px] 2xl:pl-[50px]"}
            pricingColor={proPlan.pricingColor}
            label={proPlan.label}
            price={proPlan.price}
            duration={proPlan.duration}
            planId={proPlan.planId}
            description={proPlan.description}
            buttonText={proPlan.buttonText}
            listItems={proPlan.listItems}
            // listItemsValue={[
            //   `${getPremiumPackageDetail?.regularListing}`,
            //   `${getPremiumPackageDetail?.featureListing}`,
            //   `${getPremiumPackageDetail?.noOfImages}`,
            // ]}
          />
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default PricingGuide;
